/* KALUI accessibility helpers */
(function(){
  /* mobile menu */
  const mb=document.querySelector('.menu-btn'),nav=document.getElementById('mainnav');
  if(mb&&nav){
    const close=()=>{nav.classList.remove('open');mb.setAttribute('aria-expanded','false')};
    mb.addEventListener('click',()=>{const o=!nav.classList.contains('open');nav.classList.toggle('open',o);mb.setAttribute('aria-expanded',String(o));if(o){const a=nav.querySelector('a');if(a)a.focus()}});
    nav.addEventListener('click',e=>{if(e.target.closest('a'))close()});
    document.addEventListener('keydown',e=>{if(e.key==='Escape'&&nav.classList.contains('open')){close();mb.focus()}});
  }
  /* guide tabs: roving tabindex and arrow keys */
  const tabs=document.getElementById('gtabs'),panel=document.getElementById('gpanel');
  if(tabs){
    const sync=()=>{tabs.querySelectorAll('[role=tab]').forEach(b=>{const on=b.getAttribute('aria-selected')==='true';b.tabIndex=on?0:-1;if(panel)b.setAttribute('aria-controls','gpanel')})};
    sync();new MutationObserver(sync).observe(tabs,{childList:true});
    tabs.addEventListener('keydown',e=>{
      const keys={ArrowDown:1,ArrowLeft:1,ArrowUp:-1,ArrowRight:-1,Home:'first',End:'last'};
      if(!(e.key in keys))return;e.preventDefault();
      const all=[...tabs.querySelectorAll('[role=tab]')];let i=all.indexOf(document.activeElement);
      const k=keys[e.key];i=k==='first'?0:k==='last'?all.length-1:(i+k+all.length)%all.length;
      all[i].click();setTimeout(()=>{const n=tabs.querySelectorAll('[role=tab]')[i];if(n)n.focus()},0);
    });
    if(panel){panel.tabIndex=0;
      const fixH=()=>{const h=panel.querySelector('h3');if(h&&document.querySelector('h1.gh1')){const n=document.createElement('h2');n.className='gp-h';n.innerHTML=h.innerHTML;h.replaceWith(n)}};
      fixH();new MutationObserver(fixH).observe(panel,{childList:true});}
  }
  /* cup steppers: name the person in each button */
  const rows=document.getElementById('rows');
  if(rows){
    const label=()=>rows.querySelectorAll('.prow').forEach(r=>{const who=(r.querySelector('.who')||{}).textContent||'';const [m,p]=r.querySelectorAll('.stepper button');const out=r.querySelector('output');
      if(m)m.setAttribute('aria-label','פחות כוסות ל'+(who==='אני'?'י':who));if(p)p.setAttribute('aria-label','יותר כוסות ל'+(who==='אני'?'י':who));if(out){out.setAttribute('aria-live','polite')}});
    label();new MutationObserver(label).observe(rows,{childList:true});
  }
})();
